import TaskTypeCrop from './TaskTypeCrop';
import Crop from './Crop';
import bus, { EVENTS } from './bus';

export default class ImageCrops extends PIXI.Container {
  constructor(crops, viewport, skuList, isReversed = false, params) {
    super();
    this.crops = crops;
    this.viewport = viewport;
    this.skuList = skuList;
    this.reference = params.reference;
    this.referenceImageHeight = params.referenceImageHeight;
    this.globalBoundariesAvailable = params.global_boundaries_available; // boolean
    this.missingPlanogramTasks = bus.missingList.planogram;
    this.oosPlanogramTasks = bus.outOfStockList.planogram;
    this.isReversed = isReversed;

    this.loader = new PIXI.Loader();

    if (!this.reference) {
      this.assignSkuImages();
    } else {
      this.assignUnrecognizedSkusForPlanogram();
    }

    this.drawCrops();
    if (!this.reference) this.drawTasks();

    bus.$on(EVENTS.TOGGLE_SKU_BY_TYPE, () => this.handleToggleSkuByType());
    this.handleToggleSkuByType();

    document.addEventListener('keydown', this.listenKeyboardEvents);

    this.on('removed', () => {
      document.removeEventListener('keydown', this.listenKeyboardEvents);
    });
  }

  handleToggleSkuByType() {
    const {
      show_meta_sku, show_normal_sku, show_non_sku, show_unrecognized_sku, hide_competitor_sku
    } = bus;

    const { children } = this;

    const selected = children.find(item => item.is_selected);
    // Un-select selected crop before filtering
    if (selected) {
      selected.click();
    }

    children.forEach((acc) => {
      acc.visible = true;
    });

    if (!show_meta_sku) {
      children
        .filter(item => item.crop.is_meta)
        .forEach((acc) => {
          acc.visible = false;
        });
    }

    if (!show_unrecognized_sku) {
      children
        .filter(item => item.crop.is_unrecognized)
        .forEach((acc) => {
          acc.visible = false;
        });
    }

    if (!hide_competitor_sku) {
      children
        .filter(item => item.crop.is_competitor)
        .forEach((acc) => {
          acc.visible = false;
        });
    }

    if (!show_normal_sku) {
      children
        .filter(item => item.crop.is_sku && !item.crop.is_meta)
        .forEach((acc) => {
          acc.visible = false;
        });
    }

    if (!show_non_sku) {
      children
        .filter(item => item.crop.is_nonSku)
        .forEach((acc) => {
          acc.visible = false;
        });
    }
  }

  listenKeyboardEvents = (e) => {
    const visible_children = this.children.filter(item => item.visible);

    let index = visible_children.findIndex(item => item.is_selected);

    let child = null;

    switch (e.code) {
      case 'ArrowLeft':
        index -= 1;
        child = visible_children[index];
        break;
      case 'ArrowRight':
        index += 1;
        child = visible_children[index];
        break;
      case 'Escape':
        child = visible_children.find(item => item.is_selected);

        break;

      default:

        break;
    }

    if (!child) return;

    child.click();
  }

  drawCrops() {
    this.crops.forEach(async (crop) => {
      this.addChild(new Crop(
        crop,
        this.viewport,
        this.loader,
        this.skuList,
        this.isReversed,
        { reference: this.reference, referenceImageHeight: this.referenceImageHeight, global_boundaries_available: this.globalBoundariesAvailable }
      ));
    });
  }

  assignSkuImages() {
    this.crops.forEach(async (crop, index) => {
      const sku = bus.skuListForPixiLoader.find(item => (item.id.toString() === crop.class.id.toString()));

      if (sku && sku.images) {
        this.crops[index].image_url = sku.images;
        // TODO: dont add to loader if crop exists in loader resources
        this.loader.add(`${this.crops[index].crop_id}`, `${this.crops[index].image_url}?`, { crossOrigin: 'anonymous' });
      } else if (crop.is_unrecognized) {
        this.crops[index].image_url = '/statics/report-inspector/unrecognized.png';
        this.loader.add(`${this.crops[index].crop_id}`, `${this.crops[index].image_url}?`, { crossOrigin: 'anonymous' });
      } else {
        this.crops[index].image_url = '';
      }
    });
  }

  assignUnrecognizedSkusForPlanogram() {
    this.crops.forEach(async (crop, index) => {
      if (crop.is_unrecognized) {
        this.crops[index].image_url = '/statics/report-inspector/unrecognized.png';
        this.loader.add(`${this.crops[index].crop_id}`, `${this.crops[index].image_url}?`, { crossOrigin: 'anonymous' });
      } else {
        this.crops[index].image_url = '';
      }
    });
  }

  drawTasks() {
    this.addTaskType(this.oosPlanogramTasks, 'out_of_stock');
    this.addTaskType(this.missingPlanogramTasks, 'missing');
  }

  addTaskType(taskList, type) {
    taskList.forEach(async (crop) => {
      this.addChild(new TaskTypeCrop(
        crop,
        this.viewport,
        this.loader,
        this.skuList,
        {
          reference: this.reference,
          taskType: type
        }
      ));
    });
  }
}
